import { render, staticRenderFns } from "./tableSortDialog.vue?vue&type=template&id=c5417676"
import script from "./tableSortDialog.vue?vue&type=script&lang=ts"
export * from "./tableSortDialog.vue?vue&type=script&lang=ts"
import style0 from "./tableSortDialog.vue?vue&type=style&index=0&id=c5417676&prod&lang=scss"
import style1 from "./tableSortDialog.vue?vue&type=style&index=1&id=c5417676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports